// TODO(KK): Add comments
export {};
//# sourceMappingURL=mappedSubgraphTypes.js.map